const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/oppdrag/$tluxCaseId/sletting/$slettingId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user/oppdrag/$tluxCaseId/sletting/$slettingId/")({
  loader: async ({
    params
  }) => {
    const {
      tluxCaseId,
      slettingId
    } = params;
    const res = await routeLoaderApiClient.oppdrag[":tluxCaseId"].sletting[":slettingId"].$get({
      param: {
        tluxCaseId,
        slettingId
      }
    });
    if (res.ok === false) {
      throw new Error("Failed to fetch sletting");
    }
    return {
      sletting: await res.json()
    };
  },
  head: () => ({
    meta: [{
      title: "Rediger sletting | Alice & Bob"
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});